import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: "CheckboxControl",
    model: {
        prop: 'modelValue',
        event: 'change'
    }
})
export default class CheckboxControl extends Vue {
    @Prop({ type: Boolean, default: false })
    private modelValue!: boolean;
    @Prop({ type: Boolean, default: true })
    private trueValue!: boolean;
    @Prop({ type: Boolean, default: false })
    private falseValue!: boolean;
    @Prop({ type: Boolean, default: false })
    private disabled!: boolean;
    @Prop({ type: String, default: '#e6e6e6' })
    private borderColorFalse!: string;
    @Prop({ type: String, default: '#ba0c2f' })
    private borderColorTrue!: string;
    @Prop({ type: String, default: '#ba0c2f' })
    private checkmarkColor!: string;
    @Prop({ type: String, default: '#fff' })
    private backgroundColorFalse!: string;
    @Prop({ type: String, default: '#fff' })
    private backgroundColorTrue!: string;
    @Prop({ type: String, default: '' })
    private labelText!: string;

    get shouldBeChecked() {
        return this.modelValue === this.trueValue
    }

    get borderColor() {
        let color = this.shouldBeChecked ? this.borderColorTrue : this.borderColorFalse;
        return {'border-color': color};
    }

    get backgroundColor() {
      let color = this.shouldBeChecked ? this.backgroundColorTrue : this.backgroundColorFalse;
      return {'background': color};
    }

    get isDisabledStyle() {
        let displayResult = this.disabled ? 'inherit' : 'none';
        return {'display': displayResult};
    }

    updateInput(event: any) {
        if (this.disabled) {
            return;
        }
        let isChecked = event.target.checked;
        this.$emit('change', isChecked ? this.trueValue : this.falseValue);
    }
}